import { render, staticRenderFns } from "./supportList.vue?vue&type=template&id=2b614e8a"
import script from "./supportList.vue?vue&type=script&lang=js"
export * from "./supportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports